import React from 'react';
import LocalizedStrings from 'react-localization';
import img1 from '../../img/10.png';
import img1Webp from '../../img/10.webp';
import img2 from '../../img/10-mob.png';
import img2Webp from '../../img/10-mob.webp';

function AutoBanner(props) {
  const strings = new LocalizedStrings({
    ru: {
      txt: 'Автогражданка онлайн',
      from: 'от',
    },
    ua: {
      txt: 'Автоцивілка онлайн',
      from: 'від',
    },
  });
  strings.setLanguage(props.locale);
  return (
    <section className="auto-banner banner-block container">
      <div className="flex flex_j-space-between">
        <div className="txt">
          <h3>{strings.txt} </h3>
          <div className="price">{strings.from} 450 грн</div>
        </div>
        <div className="img">
          <picture>
            <source srcSet={img1Webp} type="image/webp" />
            <img src={img1} alt="car" />
          </picture>
          <picture>
            <source srcSet={img2Webp} type="image/webp" />
            <img src={img2} alt="car" className="img-mob" />
          </picture>
        </div>
        <div className="bg-mob">
          <svg width={320} height={168} viewBox="0 0 320 168" fill="none">
            <path opacity="0.4" d="M288.265 0C304.912 0 381.071 0 397.053 0C398.709 0 400 1.34315 400 3V165C400 166.657 398.657 168 397 168H-107C-97.3429 146.025 -76.7334 127.595 -45.9531 123.696C-15.1727 119.797 40.9612 128.658 64.0694 114.481C129.839 74.1305 186.184 0 288.265 0Z" fill="url(#abg1)" />
            <path d="M399 1V165C399 166.657 397.657 168 396 168H-67C-35.508 126.603 14.5825 150.411 56.491 131.203C120.358 101.929 132.308 39.6842 204.751 29.3047C255.285 22.0642 285.675 47.5752 335.319 35.6733C367.682 27.9143 399 1 399 1Z" fill="url(#abg2)" />
            <defs>
              <linearGradient id="abg1" x1="102.008" y1={168} x2="337.596" y2="6.05435" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1487CF" />
                <stop offset="0.293" stopColor="#1487CF" />
                <stop offset={1} stopColor="#FFD83A" />
              </linearGradient>
              <linearGradient id="abg2" x1="158.044" y1="167.999" x2="395.459" y2="0.272663" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1487CF" />
                <stop offset="0.293" stopColor="#1487CF" />
                <stop offset={1} stopColor="#FFD83A" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </section>
  );
}

export default AutoBanner;
